module.exports = __webpack_public_path__ + "assets/img/11_671_big.ffad9ded.jpg";